module.exports = __webpack_public_path__ + "media/images/favicons/favicon-9aef8b2e52c9f71dd45069d56587a17e.png";